/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

import * as React from 'react';
import { ConsoleItem } from './console-session';
import { Severity } from '@theia/core/lib/common/severity';

// TODO: Remove this workaround once issue is fixed by anser.
// REF: https://github.com/IonicaBizau/anser/issues/52
const { ansiToHtml } = (require('anser') as import('anser').default);

export class AnsiConsoleItem implements ConsoleItem {

    protected readonly htmlContent: string;

    constructor(
        public readonly content: string,
        public readonly severity?: Severity
    ) {
        this.htmlContent = ansiToHtml(this.content, {
            use_classes: true,
            remove_empty: true
        });
    }

    get visible(): boolean {
        return !!this.htmlContent;
    }

    render(): React.ReactNode {
        return <div className='theia-console-ansi-console-item' dangerouslySetInnerHTML={{ __html: this.htmlContent }} />;
    }

}
